module.exports = __webpack_public_path__ + "static/media/limpieza-&-spa.0c9b9c86.png";